import { createSelector } from 'reselect';
import * as utils from '../../shared/utils';
import { isHaveTeammatePermission } from '../helpers/user';

const getTeammates = (state) => state.teammates.items;
const getRoles = (state) => state.roles.items;

const selectUser = (state) => state.user;

export const teammatesSelector = createSelector(
  getTeammates,
  getRoles,
  (teammates, roles) => teammates.map((teammate) => {
    const teammateRole = roles.find((role) => role._id === teammate.roleId);
    if (teammateRole && teammateRole.name !== teammate.roleName) {
      const updatedTeammate = { ...teammate };
      updatedTeammate.roleName = teammateRole && teammateRole.name;
      updatedTeammate.isRoleError = teammateRole && teammateRole.error;
      return updatedTeammate;
    }
    return teammate;
  }),
);

export const selectAdminRoles = createSelector(
  selectUser,
  getTeammates,
  getRoles,
  (user, teammates, roles) => utils.getTeamManagers(user, teammates, roles),
);

export const selectAccessLevel = createSelector(
  selectUser,
  (user) => {
    const { subscriptionFeatures = {}, role } = user;
    const { planId, visualSearch } = subscriptionFeatures;
    const isTrialUser = planId === 'trial';
    const isAllowManageTeam = role?.permissions?.manageTeam;

    if (visualSearch && isHaveTeammatePermission('manageTeam', user)) return 'fullAccess';

    if (isTrialUser || !visualSearch) {
      return isAllowManageTeam ? 'partialAccess' : 'noAccess';
    }

    return 'noAccess';
  },
);

export default {
  teammatesSelector,
};
